import { Icon } from "../../../../components";

const SystemHealthIcon = ({ notHealthy }: { notHealthy: boolean }) => (
  <div
    className="system-health__icon-container"
    data-testid="system_health_icon"
  >
    <Icon name="system-status-a" className="system-health__icon" />
    {notHealthy && (
      <Icon
        name="warning-circle"
        className="system-health__not-healthy-warning-icon"
      />
    )}
  </div>
);

export default SystemHealthIcon;
